const featureIT = {
    "view": {
        "table": {
            "title": "Richieste di Funzionalità",
            "column": {
                "release_name": "Nome",
                "release_artist_name": "Nome Artista Rilascio",
                "release_date": "Data di Rilascio",
                "exclusive_date": "Data Esclusiva"
            },
            "button": {
                "export_csv": "Esporta CSV"
            },
            "placeholder": {
                "search": "Cerca..."
            }
        },
        "message": {
            "subscriptionUpgrade": "Il tuo piano di abbonamento attuale non supporta questa funzionalità. Per favore <1>aggiorna</1> il tuo piano di abbonamento per usufruire di questa funzionalità.",
            "subscriptionExpired": "Il tuo abbonamento è scaduto. Per favore <1>riprendi</1> il tuo abbonamento per usufruire di questa funzionalità.",
            "noAccess": "Non hai accesso a questo modulo, contatta il team di supporto per ulteriori informazioni."
        }
    },
    "add": {
        "title": "Fatti di Marketing",
        "form": {
            "label": {
                "release": "Rilascio",
                "djTastemaker": "Feedback DJ / TasteMaker:",
                "radioSupport": "Supporto Radio",
                "marketingPR": "Marketing / PR",
                "labelReach": "Portata etichetta e artisti:"
            },
            "help_text": {
                "release": "Seleziona un rilascio per il quale desideri inviare una richiesta di funzionalità. Puoi vedere e selezionare solo i rilasci che hanno una data di rilascio generale di 22 o più giorni in anticipo. Se stai puntando a una data di rilascio esclusiva, assicurati di inviare questo modulo almeno 22 giorni prima di una (prima) data di rilascio esclusiva.",
                "djTastemaker": "Inserisci 10 feedback di DJ / Radio / Riviste nel formato 'Nome - Feedback' (Inserisci ogni feedback in una riga). Le sottomissioni contenenti 'scaricando per' non saranno promosse o inviate ai negozi online.",
                "radioSupport": "La tua canzone o un rilascio è presente in alcune stazioni radio? In tal caso, nomina la stazione e inserisci il link corrispondente alla loro pagina dove è visibile che stanno promuovendo o suonando le tue canzoni.",
                "marketingPR": "(Interviste, blog, recensioni, articoli di riviste) - Elenca tutte le attività di stampa e marketing impegnate per questo rilascio. Non obbligatorio ma essenzialmente importante per distinguersi dalla concorrenza.",
                "labelReach": "La quantità combinata (etichetta e artisti) di follower su Facebook, Instagram, SoundCloud e YouTube. <strong>Inserisci ogni piattaforma e numero di follower in una nuova riga</strong>."
            },
            "button": {
                "submit": "Invia"
            },
            "message": {
                "releaseRequired": "È richiesto un rilascio esistente",
                "featureRequestAlreadyExists": "La richiesta di funzionalità per questo rilascio è già stata effettuata"
            }
        },
        "message": {
            "success": "La richiesta di funzionalità è stata aggiunta!",
            "error": "Qualcosa è andato storto! Per favore aggiorna la pagina e riprova!"
        },
        "modal": {
            "confirm": {
                "header": "Nuova richiesta di funzionalità",
                "body": "Questa richiesta di funzionalità deve essere inviata almeno 21 giorni prima della prima data (esclusiva o generale, qualunque venga prima). Purtroppo, le sottomissioni tardive non possono essere prese in considerazione. Vuoi inviare la tua richiesta di funzionalità?"
            }
        }
    }
};

export default featureIT;